import { html } from 'lit-element';

import { Form, mapFormDispatchToEvents } from '@elab/components/connected/forms/Form';
import { COMPONENT_CONNECT, COMPONENT_DISCONNECT } from '@elab/core/utils/dynaReduxHelpers';
import connect from '@elab/core/store/connect';
import { actions as coreActions } from '@elab/core/store/core';
import analytics from '@elab/core/utils/analytics';

import { reducers, sagaFactory, storeName } from './redux';

export class NewsletterSubscriptionForm extends Form {
    constructor() {
        super();
        this.storeName = storeName;
    }

    afterConnect() {
        super.afterConnect();
        analytics.handleNewsletterSubscriptionLoading();
    }

    render() {
        return html`
            <form
                class="form--flex ${this.formClassName}"
                @focus=${this.handleFocus}
                @blur=${this.handleBlur}
                @submit=${this.submit}
            >
                <v-slot name="content"></v-slot>
            </form>
        `;
    }
}

const mapDispatchToEvents = (dispatch, ctx) => ({
    [COMPONENT_CONNECT]: () => {
        dispatch(coreActions.addReducer(ctx.storeName, reducers));
        const saga = sagaFactory(ctx.formId);
        dispatch(coreActions.addSaga(ctx.storeName, saga));
    },
    [COMPONENT_DISCONNECT]: () => {
        dispatch(coreActions.removeSaga(ctx.storeName));
        dispatch(coreActions.removeReducer(ctx.storeName));
    },
    ...mapFormDispatchToEvents(dispatch, ctx),
});

export default () =>
    customElements.define(
        'e2-newsletter-subscription-form',
        connect(null, mapDispatchToEvents)(NewsletterSubscriptionForm),
    );
